export class FindAllGroupsError {
  public static readonly type = '[Organisation/Group/List] FindAllGroupsError';
  constructor(public readonly error: Error) {}
}
